import { Col, Container, Row } from "react-bootstrap";
import "./OurStore.css";
import OurStoreBanner from "./OurStoreBanner";
import fifteen from "../assets/img/our-store-page/fifteen.webp";
import sixteen from "../assets/img/our-store-page/sixteen.webp";
import seventeen from "../assets/img/our-store-page/seventeen.webp";
import eighteen from "../assets/img/our-store-page/eighteen.webp";
import one from "../assets/img/our-store-page/one.webp";
import two from "../assets/img/our-store-page/two.webp";
import three from "../assets/img/our-store-page/three.webp";
import four from "../assets/img/our-store-page/four.webp";
import five from "../assets/img/our-store-page/five.webp";
import six from "../assets/img/our-store-page/six.webp";
import seven from "../assets/img/our-store-page/seven.webp";
import eight from "../assets/img/our-store-page/eight.webp";
import nine from "../assets/img/our-store-page/nine.webp";
import ten from "../assets/img/our-store-page/ten.webp";
import eleven from "../assets/img/our-store-page/eleven.webp";
import twelve from "../assets/img/our-store-page/twelve.webp";
import thirteen from "../assets/img/our-store-page/thirteen.webp";
import fourteen from "../assets/img/our-store-page/fourteen.webp";
import { Helmet } from "react-helmet";

export default function OurStore() {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>Our Store | Sreehari Diamond Laboratory</title>
        <meta
          name="description"
          content="Explore our store to see an exclusive collection of certified diamonds, custom designs, and expert craftsmanship. "
        />
        <meta
          name="keywords"
          content="Our store, diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Diamond Hologram Stickers, Hologram Stickers for Certificates, Best diamond online services"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="Our Store | Sreehari Diamond Laboratory"
        />
        <meta
          property="og:description"
          content="Explore our store to see an exclusive collection of certified diamonds, custom designs, and expert craftsmanship. "
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://sreeharidiamondlab.com/our-store"
        />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/fifteen.85dbd1a65bca2ea077d8.webp"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Our Store | Sreehari Diamond Laboratory"
        />
        <meta
          name="twitter:description"
          content="Explore our store to see an exclusive collection of certified diamonds, custom designs, and expert craftsmanship. "
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/fifteen.85dbd1a65bca2ea077d8.webp"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link
          rel="canonical"
          href="https://sreeharidiamondlab.com/our-store"
        />{" "}
      </Helmet>
      <OurStoreBanner />
      <section className="section-spacing-x section-spacing-y about-us">
        <Container fluid>
          <h2 className="heading mb-3 text-center"> Our Store</h2>
          <p className="para-content mb-3 text-center">
            Explore our diamond lab store, where brilliance meets
            sustainability. We specialize in certified diamonds that rival mined
            gems in beauty, purity, and durability. From timeless solitaires to
            custom designs, every piece reflects innovation, trust, and elegance
            designed to make your moments truly sparkle.
          </p>

          <Row>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={fifteen} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={sixteen} className="img-fluid" />
              </div>
            </div>{" "}
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={seventeen} className="img-fluid" />
              </div>
            </div>{" "}
            <div className="col-lg-3 mb-4 ">
              <div className="our-store-card border rounded">
                <img src={eighteen} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={one} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={two} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={three} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={four} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={five} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={six} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={seven} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={eight} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={nine} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={ten} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={eleven} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={twelve} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={thirteen} className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="our-store-card border rounded">
                <img src={fourteen} className="img-fluid" />
              </div>
            </div>
          </Row>
        </Container>
      </section>
    </>
  );
}
